import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import { Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from '../../../../context/ApplicationContext';
import { DisplayDateTime } from '../../../../utils/formats';
import { ANTRAGS_FORMULAREN } from '../../../../lib/constants/constant';
import { enumT } from '../../../../utils/helper';
import AnsprechPartnerKontakt from '../antrag-components/AnsprechPartnerKontakt';
import RightIconButton from '../antrag-components/RightIconButton';

// import schemas
import Schema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;

const MittelabrufRightSidebar: FC<{}> = () => {
	const { application } = useApplication();
	const location = useLocation();
	const [showAPKontaktdaten, setShowAPKontaktdaten] = useState(false);
	const mittelabrufIndexFromState = Number(get(location, 'state.mittelabrufIndex', 0)) || 0;
	const mittelabrufNummer = useMemo(() => {
		if (mittelabrufIndexFromState > 0) return mittelabrufIndexFromState;

		const currentId = get(application, 'id');
		const currentProjektjahr = get(application, P.Allgemein_Haushaltsjahr.path);
		const allMittelabrufe = get(application, P.Foerderantrag.schema.attributes.Foerderantrag_Mittelabrufs.path, []);
		const mittelabrufeForYear = allMittelabrufe.filter((eachMA: any) => get(eachMA, P.Allgemein_Haushaltsjahr.path) === currentProjektjahr);

		const currentIndex = mittelabrufeForYear.findIndex((eachMA: any) => get(eachMA, 'id') === currentId);
		return currentIndex >= 0 ? currentIndex + 1 : 1;
	}, [application, mittelabrufIndexFromState]);

	const handleOpenDialog = () => {
		setShowAPKontaktdaten(true);
	};
	const handleCloseDialog = () => {
		setShowAPKontaktdaten(false);
	};

	// const handleDownloadAntrag = async () => {
	// 	await DownloadMittelabrufPDF(application, readOnly, saveApplication);
	// };

	return (
		<>
			<AnsprechPartnerKontakt open={showAPKontaktdaten} onClose={handleCloseDialog} application={get(application, P.Foerderantrag.path, {})} />
			<RightSidebarPaper>
				<span>
					<Typography> Online-Formular: </Typography>
					<Typography fontWeight={500} variant='body1'>
						Mittelabruf #{mittelabrufNummer}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Mittelabrufstatus_Mittelabrufstatus.path))}
					</Typography>
				</span>
				<span>
					<Typography>Projektjahr:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Allgemein_Haushaltsjahr.path)}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Projekttitel:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Typography>
				</span>
				{(() => {
					const antragsformular = get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');
					const isTargetProgram = [
						ANTRAGS_FORMULAREN.StartUpStipendium,
						ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit,
						ANTRAGS_FORMULAREN.Kreativwirtschaft,
					].includes(antragsformular);

					return (
						<span>
							<Typography variant='body1'>{isTargetProgram ? 'Projektnummer:' : 'Referenz-Nummer:'}</Typography>
							<Typography fontWeight={500} variant='body1'>
								{isTargetProgram ?
									get(application, P.Foerderantrag.schema.attributes.Allgemein_HA_Projekt_Nr.path, 'ausstehend')
								:	get(application, P.Foerderantrag.schema.attributes.Allgemein_Referenz_Nr.path, 'ausstehend')}
							</Typography>
						</span>
					);
				})()}
				<span>
					<Typography variant='body1'>Mittelabruf-Eingangsnummer:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Allgemein_Eingangsnummer.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Förderprogramm:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, ''))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, P.Allgemein_Geaendert_Am_Portal.path, ''))}
					</Typography>
				</span>
			</RightSidebarPaper>

			<Stack direction={'row'} spacing={3} sx={{ mt: '2rem' }}>
				{/* {(
					get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '') &&
					get(application, P.Foerderantrag.schema.attributes.Allgemein_Kurzwort.path, '')
				) ?
					<RightIconButton onClick={handleDownloadAntrag} icon={<DownloadIcon />} tooltipTitle='Aktuellen Status herunterladen' />
				:	null} */}
				<RightIconButton onClick={handleOpenDialog} icon={<AddIcCallIcon />} tooltipTitle='Kontaktinformationen der Ansprechpartner' />
			</Stack>
		</>
	);
};
export default MittelabrufRightSidebar;
